import React, { useEffect, useState } from 'react'
import Modal from './Modal'

interface EmailConfirmationModalProps {
  open: boolean
  email: string
  onClose: () => void
  onGoToLogin: () => void
}

export default function EmailConfirmationModal({ open, email, onClose, onGoToLogin }: EmailConfirmationModalProps) {
  const [resendLoading, setResendLoading] = useState(false)
  const [resendError, setResendError] = useState<string | null>(null)
  const [resendSuccess, setResendSuccess] = useState(false)
  const [cooldown, setCooldown] = useState(0)

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined
    if (cooldown > 0) {
      timer = setTimeout(() => setCooldown(cooldown - 1), 1000)
    }
    return () => timer && clearTimeout(timer)
  }, [cooldown])

  async function handleResend() {
    if (cooldown > 0) return
    setResendLoading(true)
    setResendError(null)
    setResendSuccess(false)
    try {
      const res = await fetch('/api/resend-confirmation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
      if (!res.ok) {
        const data = await res.json()
        setResendError(data.error || 'Erro ao reenviar e-mail.')
        setResendSuccess(false)
      } else {
        setResendSuccess(true)
        setCooldown(30)
        setResendError(null)
      }
    } catch {
      setResendError('Erro de rede.')
      setResendSuccess(false)
    } finally {
      setResendLoading(false)
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex flex-col gap-4 items-center">
        <span className="text-green-400 text-lg font-semibold">Cadastro realizado!</span>
        <span className="text-zinc-300 text-center">
          Enviamos um e-mail para <span className="font-bold text-white">{email}</span>.<br />
          Confirme sua conta antes de fazer login.<br />
          <span className="text-zinc-500 text-sm mt-1 block">Caso não encontre o e-mail, verifique a caixa de spam.</span>
        </span>
        <button
          className="px-4 py-2 rounded bg-[#ffa300] text-black font-bold hover:bg-[#ff8c00] transition disabled:opacity-60"
          onClick={handleResend}
          disabled={resendLoading || cooldown > 0}
        >
          {resendLoading
            ? 'Reenviando...'
            : cooldown > 0
              ? `Reenviar e-mail em ${cooldown}s`
              : 'Reenviar e-mail de confirmação'}
        </button>
        {resendSuccess && <span className="text-green-300">E-mail reenviado com sucesso!</span>}
        {resendError && <span className="text-red-400">{resendError}</span>}
        <button
          className="mt-2 px-4 py-2 rounded bg-[#ffa300] text-black font-bold hover:bg-[#ff8c00] transition"
          onClick={onGoToLogin}
        >
          Ir para login
        </button>
      </div>
    </Modal>
  )
} 